import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import add_white from "../../../assets/images/icons/plus-02.svg";
import {
  GeneralButton,
  InfiniteScroll,
  Modal
} from "../../../components";
import { EndPoints } from "../../../Constants/endpoints";
import { IsProfileCompleted } from "../../../Share";
import TemplateCard from "./TemplateCard";

function MakeNewTemplate() {
  const navigate = useNavigate();
  const [defaultTemplatesData, setDefaultTemplatesData] = useState<any[]>();
  const [templatesData, setTemplatesData] = useState<any[]>([]);
  const [openPatientModal, setOpenPatientModal] = useState<boolean>(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState<string | null>(
    null,
  );

  const { t } = useTranslation();

  const handleTemplateSelect = (templateId: string) => {
    setSelectedTemplateId(templateId);
  };
  const closeModel = () => {
    setOpenPatientModal(false);
  };

  useEffect(() => {
    defaultTemplatesData?.length === 1 &&
      templatesData?.length === 0 &&
      setSelectedTemplateId(defaultTemplatesData?.[0]?.Id);
  }, [defaultTemplatesData]);

  return (
    <div>
      <IsProfileCompleted
        title="complete_your_profile_to_make_new_template"
        onAllowedClick={() => setOpenPatientModal(true)}
      >
        <GeneralButton
          title={t(
            defaultTemplatesData?.length === 1 && templatesData?.length === 0
              ? "make_new_template"
              : "choose_from_templates",
          )}
          icon={add_white}
          styleClasses="!px-4"
        />
      </IsProfileCompleted>
      <Modal
        onClose={closeModel}
        width="max-w-[80vw]"
        customStyle="overflow-hidden"
        isOpen={openPatientModal}
        header={t("make_new_template")}
      >
        <h2>{t("dome_care_templates")}</h2>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {defaultTemplatesData?.map((template: any, i) => (
            <TemplateCard
              key={i}
              item={template}
              isSelectStyle
              isSelected={selectedTemplateId === template.Id}
              onSelect={handleTemplateSelect}
            />
          ))}
          <InfiniteScroll
            Count={10}
            skeletonCount={4}
            endpoint={EndPoints.MedicalHistoryTypes}
            getAllParams={{
              IsGeneralMedical: true,
            }}
            getData={(data) => setDefaultTemplatesData(data)}
            renderSkeleton={
              <div className="h-40 animate-pulse rounded-lg bg-gray-400"></div>
            }
          />
        </div>
        <div className="">
          <h3 className="mb-4">{t("my_templates")}</h3>
          <div className="grid max-h-[30vh] grid-cols-1 gap-4 overflow-auto sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
            {templatesData?.map((template: any, i) => (
              <TemplateCard
                key={i}
                item={template}
                isSelectStyle
                isSelected={selectedTemplateId === template.Id}
                onSelect={handleTemplateSelect}
              />
            ))}
            <InfiniteScroll
              Count={10}
              skeletonCount={4}
              endpoint={EndPoints.MedicalHistoryTypes}
              getAllParams={{
                IsGeneralMedical: false,
              }}
              getData={(data) => setTemplatesData(data)}
              renderSkeleton={
                <div className="h-40 animate-pulse rounded-lg bg-gray-400"></div>
              }
            />
          </div>
        </div>
        <div className="mt-3 flex justify-end gap-4">
          <GeneralButton
            title={t("cancel")}
            color="lite"
            fontColor="black"
            onClick={closeModel}
          />
          <GeneralButton
            title={t("start_customizing")}
            onClick={() =>
              navigate(
                `/medical-record-templates/${selectedTemplateId}/customize`,
              )
            }
            disabled={selectedTemplateId ? false : true}
          />
        </div>
      </Modal>
    </div>
  );
}

export default MakeNewTemplate;
